export const educationData = [
    {
        id: 1,
        institution: 'Guru Gobind Singh Indrprastha University',
        course: 'Bachelors of Technology-CSE',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'Basava International School',
        course: 'Senior Secondary Certificate',
        startYear: '2019',
        endYear: '2020'
    },
    // {
    //     id: 3,
    //     institution: 'Hawking University, Cambridge',
    //     course: 'Master of Technology',
    //     startYear: '2019',
    //     endYear: 'Present'
    // },
]